import React from 'react';

import { BaseIconProps } from './types';

const TwoSparklesIcon = ({
  fillColor,
  size = 24,
}: BaseIconProps): React.ReactNode => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.12888 18.1962C9.06011 18.1941 9.00557 18.1378 9.00454 18.069C8.98914 17.0431 8.78193 16.0291 8.39347 15.0805C7.98944 14.0939 7.39724 13.1975 6.65069 12.4425C5.90414 11.6874 5.01787 11.0886 4.0425 10.68C3.06712 10.2715 2.02174 10.0614 0.966066 10.0616C0.344904 10.0616 0.344904 9.93117 0.966066 9.93117C2.02174 9.93138 3.06712 9.72122 4.0425 9.3127C5.01787 8.90418 5.90414 8.30529 6.65069 7.55025C7.39724 6.79521 7.98944 5.8988 8.39347 4.91221C8.78145 3.96484 8.98863 2.95213 9.00448 1.92757C9.00557 1.85729 9.06245 1.80029 9.13274 1.80029C9.20309 1.80029 9.25999 1.85736 9.26101 1.92769C9.27591 2.95289 9.48237 3.96639 9.86991 4.91462C10.2735 5.90212 10.8655 6.79945 11.6122 7.55533C12.3588 8.3112 13.2454 8.91079 14.2213 9.3198C15.1972 9.72882 16.2432 9.93924 17.2995 9.93903C17.8337 9.93903 17.8337 10.0694 17.2995 10.0694C16.2439 10.0692 15.1985 10.2794 14.2231 10.6879C13.2477 11.0964 12.3615 11.6953 11.6149 12.4503C10.8684 13.2054 10.2762 14.1018 9.87214 15.0884C9.48467 16.0345 9.27753 17.0458 9.26119 18.069C9.26005 18.1408 9.20071 18.1985 9.12888 18.1962Z"
        fill={fillColor}
      />
      <path
        d="M19.1174 23.0004C19.0768 23.0004 19.044 22.9675 19.0434 22.9269C19.0243 21.6906 18.5341 20.5091 17.675 19.6335C16.7989 18.7406 15.6108 18.239 14.3721 18.239C14.0088 18.239 14.0088 18.1617 14.3721 18.1617C15.6108 18.1617 16.7989 17.6602 17.675 16.7673C18.5341 15.8917 19.0243 14.7102 19.0434 13.4739C19.044 13.4333 19.0768 13.4004 19.1174 13.4004C19.1579 13.4004 19.1908 13.4333 19.1914 13.4738C19.2005 14.0742 19.3209 14.6677 19.5465 15.2229C19.7813 15.8006 20.1254 16.3256 20.5593 16.7677C20.9931 17.2099 21.5082 17.5606 22.075 17.7998C22.6418 18.039 23.2493 18.162 23.8627 18.1617C24.1786 18.1617 24.1786 18.239 23.8627 18.239C23.2493 18.2388 22.6418 18.3618 22.075 18.601C21.5082 18.8402 20.9931 19.1909 20.5593 19.633C20.1254 20.0752 19.7813 20.6001 19.5465 21.1779C19.3209 21.7331 19.2005 22.3265 19.1914 22.9269C19.1908 22.9675 19.1579 23.0004 19.1174 23.0004Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default TwoSparklesIcon;
